"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyMainLinks = void 0;
var react_i18next_1 = require("react-i18next");
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var CompanyMainLinks = function () {
    var _a = react_i18next_1.useTranslation("jds"), t = _a.t, i18n = _a.i18n;
    var locale = i18n.language;
    var NAVIGATION_LINKS = [
        {
            href: "https://www.jagex.com/" + locale + "/careers",
            label: t("footer:menu:careers", "Careers")
        },
        {
            href: "https://www.jagex.com/" + locale + "/contact-us",
            label: t("footer:menu:contact", "Contact")
        },
        {
            href: "https://www.jagex.com/" + locale + "/charitable-giving",
            label: t("footer:menu:charity", "Charity")
        },
        {
            href: "https://www.jagex.com/" + locale + "/living-games",
            label: t("footer:menu:livingGames", "Living Games")
        }
    ];
    return (theme_ui_1.jsx(theme_ui_1.Flex, { as: "nav", sx: {
            flexDirection: ["column", "column", "column", "column", "row"],
            justifyContent: [null, null, null, null, "flex-end"],
            textAlign: "center",
        } }, NAVIGATION_LINKS.map(function (_a) {
        var href = _a.href, label = _a.label;
        return (theme_ui_1.jsx(theme_ui_1.Link, { href: href, key: label, target: "_blank", sx: {
                fontSize: theme_1.theme.fontSizes[2],
                textDecoration: "none",
                color: theme_1.theme.colors.white,
                marginBottom: [22, 22, 22, 22, 1],
                ":not(:first-child)": {
                    ml: [null, null, null, null, "30px"]
                }
            } }, label));
    })));
};
exports.CompanyMainLinks = CompanyMainLinks;
